
import '../styles/main.scss';

import './global';
import './app';

import init from './app/init';

import store from './store';
import * as EventTypes from './store/events';
import getScrollbarWidth from './utils/getScrollbarWidth';

// page on ready
function onReady()
{
	if (BX.Browser.isIE11())
	{
		BX.loadExt('redsign.eshop24.polyfill.svgxuse');
	}

	init();
}

store.subscribe(EventTypes.UI_FIXED_SCROLLBAR, () => {
	document.body.style.paddingRight = getScrollbarWidth() + 'px';
	document.body.style.overflow = 'hidden';
});

store.subscribe(EventTypes.UI_UNFIXED_SCROLLBAR, () => {
	document.body.style.removeProperty('overflow');
	document.body.style.removeProperty('padding-right');
});


// composite data recieved
function onFrameDataReceived(json = {})
{
	if (!(json.dynamicBlocks || []).length)
	{
		return;
	}

	json.dynamicBlocks.forEach((block, index) =>
	{
		init([], document.querySelector(block.ID));
	})
}

$(onReady);
if (window.frameCacheVars !== undefined)
{
	BX.addCustomEvent("onFrameDataReceived", (json) => onFrameDataReceived(json));
}